// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB1zW3d8W7sIrc42a3FzKUYBOKq67kRKFw",
  authDomain: "fir-tester-2850.firebaseapp.com",
  projectId: "fir-tester-2850",
  storageBucket: "fir-tester-2850.firebasestorage.app",
  messagingSenderId: "825638836993",
  appId: "1:825638836993:web:86b87d59e4e6fb2cec1900"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);